import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

const { color, borderRadius, spacing, font } = theme;
const { purple30, purple70, blackOpacity12, grey10, grey20 } =
  color.designSystem;

export const Container = styled.div<{ isSelected: boolean }>`
  color: ${color.black};
  border-radius: ${borderRadius.large};
  margin-top: ${theme.spacing.small};
  margin-bottom: ${theme.spacing.small};
  padding: ${spacing.medium};
  border: ${({ isSelected }) =>
    `2px ${isSelected ? `solid ${purple70}` : `dashed ${blackOpacity12}`}`};
  display: flex;
  gap: ${spacing.medium};
  justify-content: flex-start;
  background-color: ${({ isSelected }) => (isSelected ? purple30 : grey10)};
  ${({ isSelected }) =>
    !isSelected &&
    `&:hover {
        background-color: ${grey20};
    }`}
`;
export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Title = styled.p`
  font-size: ${font.size.large} !important;
  font-weight: 500;
  margin: 0 !important;
`;

export const Description = styled.p`
  font-weight: 400;
  margin-bottom: 0 !important;
  opacity: 0.6;
`;
